import { Widget } from './form-widget.model';
import moment from 'moment';
import { parseLocalDateString } from '../helpers/date-utils';

export class FbEmrInsuranceInfoWidget extends Widget {
  private formData: any;
  private insurancePayers: any[] = [];
  constructor(data?: any, formData?: any) {
    super(data);
    this.formData = formData;
    this.name = 'fb-emr-insurance-info';
    this.title = 'Insurance Information';

    if (!this.properties.text) {
      this.properties.text = { title: 'Header', value: 'Insurance Information' };
    }
    if (!this.properties.content) {
      this.properties.content = {
        title: 'Description',
        value: '',
        placeholder: 'Add a description or, leave blank',
      };
    }
    if (!this.properties.value) {
      this.properties.value = { title: 'Value', value: '' };
    }
    if (!this.properties.items) {
      this.properties.items = {
        title: 'Items',
        value: [
          {
            title: 'Primary Insurance',
            name: 'primary-insurance',
            value: true,
            visible: true,
            nested: true,
            mandatory: true,
            items: [
              {
                title: 'Primary Insurance Information',
                value: true,
                type: 'text',
                visible: true,
                mandatory: true,
                nested: true,
                items: [
                  {
                    title: 'Policy Information',
                    value: true,
                    visible: true,
                    nested: true,
                    mandatory: true,
                    items: [
                      {
                        title: 'Plan Name',
                        placeholder: 'Insurance Plan',
                        name: 'company_code',
                        value: '',
                        type: 'dropdown',
                        visible: true,
                        required: true,
                        mapping: '',
                        toggleVisibility: false,
                        fullRow: true,
                      },
                      {
                        title: 'Effective Date',
                        placeholder: 'Effective Date',
                        name: 'effective_date',
                        value: '',
                        type: 'date',
                        visible: true,
                        required: false,
                        mapping: '',
                        toggleVisibility: true,
                      },
                      {
                        title: 'Expiration Date',
                        placeholder: 'Expiration Date',
                        name: 'expiration_date',
                        value: '',
                        type: 'date',
                        visible: true,
                        required: false,
                        mapping: '',
                        toggleVisibility: true,
                      },
                      {
                        title: 'Policy Number',
                        placeholder: 'Policy Number',
                        name: 'policy_number',
                        value: '',
                        type: 'text',
                        visible: true,
                        required: true,
                        mapping: '',
                        toggleVisibility: false,
                      },
                      {
                        title: 'Group Number',
                        placeholder: 'Group Number',
                        name: 'group_number',
                        value: '',
                        type: 'text',
                        visible: true,
                        required: false,
                        mapping: '',
                        toggleVisibility: true,
                      },
                    ],
                  },
                  {
                    title: 'Address',
                    value: true,
                    visible: true,
                    nested: true,
                    mandatory: true,
                    items: [
                      {
                        title: 'Address 1',
                        placeholder: 'Address 1',
                        name: 'address1',
                        value: '',
                        type: 'text',
                        visible: true,
                        required: true,
                        mandatory: true,
                        mapping: '',
                        toggleVisibility: false,
                      },
                      {
                        title: 'Address 2',
                        placeholder: 'Address 2',
                        name: 'address2',
                        value: '',
                        type: 'text',
                        visible: true,
                        required: false,
                        mapping: '',
                        toggleVisibility: true,
                      },
                      {
                        title: 'City',
                        placeholder: 'City',
                        name: 'city',
                        value: '',
                        type: 'text',
                        visible: true,
                        required: true,
                        mapping: '',
                        toggleVisibility: false,
                      },
                      {
                        title: 'State',
                        placeholder: 'State',
                        name: 'state',
                        value: '',
                        type: 'text',
                        visible: true,
                        required: true,
                        mapping: '',
                        toggleVisibility: false,
                      },
                      {
                        title: 'ZIP',
                        placeholder: 'ZIP',
                        name: 'postal',
                        value: '',
                        type: 'text',
                        visible: true,
                        required: true,
                        mapping: '',
                        toggleVisibility: false,
                      },
                      {
                        title: 'Phone',
                        placeholder: 'Phone',
                        name: 'phone_number',
                        value: '',
                        type: 'text',
                        visible: true,
                        required: false,
                        mapping: '',
                        toggleVisibility: true,
                      },
                    ],
                  },
                  {
                    title: 'Policy Holder',
                    value: true,
                    visible: true,
                    nested: true,
                    mandatory: true,
                    items: [
                      {
                        title: 'Relationship to Client',
                        placeholder: 'Relationship to Client',
                        name: 'ph_relationship',
                        value: '',
                        type: 'dropdown',
                        visible: true,
                        required: true,
                        mapping: '',
                        toggleVisibility: false,
                        optionValueKey: 'value',
                        optionLabelKey: 'label',
                        options: [
                          { value: '', label: '' },
                          { value: 'self', label: 'Self' },
                          { value: 'spouse', label: 'Spouse' },
                          { value: 'parent', label: 'Parent' },
                          { value: 'guarantor', label: 'Guarantor' },
                          { value: 'nextofkin', label: 'Next of Kin' },
                          { value: 'other', label: 'Other' },
                        ],
                      },
                      {
                        title: 'Employer Name',
                        placeholder: 'Employer Name',
                        name: 'ph_employer',
                        value: '',
                        type: 'text',
                        visible: true,
                        required: false,
                        mapping: '',
                        toggleVisibility: true,
                      },
                      {
                        title: 'First Name',
                        placeholder: 'First Name',
                        name: 'ph_first_name',
                        value: '',
                        type: 'text',
                        visible: true,
                        required: true,
                        mapping: '',
                        toggleVisibility: false,
                      },
                      {
                        title: 'Last Name',
                        placeholder: 'Last Name',
                        name: 'ph_last_name',
                        value: '',
                        type: 'text',
                        visible: true,
                        required: true,
                        mapping: '',
                        toggleVisibility: false,
                      },
                      {
                        title: 'Gender',
                        placeholder: 'Gender',
                        name: 'ph_gender',
                        value: '',
                        type: 'dropdown',
                        visible: true,
                        required: true,
                        mapping: '',
                        toggleVisibility: false,
                        optionValueKey: 'value',
                        optionLabelKey: 'title',
                        options: [
                          {
                            title: 'Male',
                            value: 'male',
                          },
                          {
                            title: 'Female',
                            value: 'female',
                          },
                          {
                            title: 'Other',
                            value: 'other',
                          },
                          {
                            title: 'Unknown',
                            value: 'unknown',
                          },
                        ],
                      },
                      {
                        title: 'Date of Birth',
                        placeholder: 'Date of Birth',
                        name: 'ph_birth_date',
                        value: '',
                        type: 'date',
                        visible: true,
                        required: true,
                        mapping: '',
                        toggleVisibility: false,
                      },
                      {
                        title: 'Address 1',
                        placeholder: 'Address 1',
                        name: 'ph_address1',
                        value: '',
                        type: 'text',
                        visible: true,
                        required: true,
                        mapping: '',
                        toggleVisibility: false,
                      },
                      {
                        title: 'Address 2',
                        placeholder: 'Address 2',
                        name: 'ph_address2',
                        value: '',
                        type: 'text',
                        visible: true,
                        required: false,
                        mapping: '',
                        toggleVisibility: true,
                      },
                      {
                        title: 'City',
                        placeholder: 'City',
                        name: 'ph_city',
                        value: '',
                        type: 'text',
                        visible: true,
                        required: true,
                        mapping: '',
                        toggleVisibility: false,
                      },
                      {
                        title: 'State',
                        placeholder: 'State',
                        name: 'ph_state',
                        value: '',
                        type: 'text',
                        visible: true,
                        required: true,
                        mapping: '',
                        toggleVisibility: false,
                      },
                      {
                        title: 'Zip/Postal',
                        placeholder: 'Zip/Postal',
                        name: 'ph_postal',
                        value: '',
                        type: 'text',
                        visible: true,
                        required: true,
                        mapping: '',
                        toggleVisibility: false,
                      },
                      {
                        title: 'Phone Number',
                        placeholder: 'Phone Number',
                        name: 'ph_phone_number',
                        value: '',
                        type: 'text',
                        visible: true,
                        required: true,
                        mapping: '',
                        toggleVisibility: false,
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            title: 'Secondary Insurance',
            value: false,
            visible: true,
            nested: true,
            toggleVisibility: true,
            items: [],
          },
          {
            title: 'Tertiary Insurance',
            value: false,
            visible: true,
            nested: true,
            toggleVisibility: true,
            items: [],
          },
        ],
      };
    }
  }

  private validationErrors: string[] = [];

  isValid(): boolean {
    this.validationErrors = [];
    if (!this.properties?.items?.value || !Array.isArray(this.properties.items.value)) {
      if (this.properties.mandatory?.value) {
        this.validationErrors.push('No insurance containers found but container is mandatory');
        return false;
      }
      return true;
    }

    const insuranceContainers = this.properties.items.value;

    for (const container of insuranceContainers) {
      if (container.value === false || container.visible === false) {
        continue;
      }

      if (container.mandatory && (!container.items || container.items.length === 0)) {
        this.validationErrors.push(`Container "${container.title}" is mandatory but has no items`);
        return false;
      }

      if (container.items && Array.isArray(container.items)) {
        for (const insuranceEntry of container.items) {
          if (insuranceEntry.value === false || insuranceEntry.visible === false) {
            continue;
          }

          if (
            insuranceEntry.mandatory &&
            (!insuranceEntry.items || insuranceEntry.items.length === 0)
          ) {
            this.validationErrors.push(
              `Insurance entry "${insuranceEntry.title}" is mandatory but has no groups`,
            );
            return false;
          }

          if (insuranceEntry.items && Array.isArray(insuranceEntry.items)) {
            for (const group of insuranceEntry.items) {
              if (group.value === false || group.visible === false) {
                continue;
              }

              if (group.mandatory && (!group.items || group.items.length === 0)) {
                this.validationErrors.push(`Group "${group.title}" is mandatory but has no fields`);
                return false;
              }

              if (group.items && Array.isArray(group.items)) {
                for (const field of group.items) {
                  if (field.visible === false) {
                    continue;
                  }

                  if (field.required === true) {
                    const isValidField = this.validateField(field);
                    if (!isValidField) {
                      this.validationErrors.push(
                        `Required field "${field.title}" in "${group.title}" is empty`,
                      );
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    return this.validationErrors.length === 0;
  }

  private validateField(field: any): boolean {
    const value = field.value;

    switch (field.type) {
      case 'text':
      case 'dropdown':
        return value !== null && value !== undefined && value !== '';

      case 'date':
        return value !== null && value !== undefined && value !== '' && !isNaN(Date.parse(value));

      default:
        return value !== null && value !== undefined && value !== '';
    }
  }

  getValidationErrors(): string[] {
    return this.validationErrors;
  }

  public getMetadata() {
    if (!this.properties?.items?.value) {
      return {};
    }

    const metadata: any = {
      secondary_insurance: [],
      tertiary_insurance: [],
    };

    const containersByType = {
      primary: [] as any[],
      secondary: [] as any[],
      tertiary: [] as any[],
    };

    this.properties.items.value.forEach((container: any) => {
      if (container.value === false || container.visible === false) {
        return;
      }

      const containerName = container.name || '';
      const containerTitle = (container.title || '').toLowerCase();

      if (containerName === 'primary-insurance' || containerTitle.includes('primary')) {
        containersByType.primary.push(container);
      } else if (containerName === 'secondary-insurance' || containerTitle.includes('secondary')) {
        containersByType.secondary.push(container);
      } else if (containerName === 'tertiary-insurance' || containerTitle.includes('tertiary')) {
        containersByType.tertiary.push(container);
      }
    });

    for (const container of containersByType.primary) {
      if (container.items && container.items.length > 0) {
        const firstInsurance = container.items[0];
        if (firstInsurance && firstInsurance.value !== false) {
          const data = this.extractInsuranceData(firstInsurance);
          if (data && Object.keys(data).length > 0) {
            metadata.primary_insurance = data;
            break;
          }
        }
      }
    }

    for (const container of containersByType.secondary) {
      if (container.items && Array.isArray(container.items)) {
        container.items.forEach((insuranceItem: any) => {
          if (insuranceItem.value !== false && insuranceItem.visible !== false) {
            const data = this.extractInsuranceData(insuranceItem);
            if (data && Object.keys(data).length > 0) {
              metadata.secondary_insurance.push(data);
            }
          }
        });
      }
    }

    for (const container of containersByType.tertiary) {
      if (container.items && Array.isArray(container.items)) {
        container.items.forEach((insuranceItem: any) => {
          if (insuranceItem.value !== false && insuranceItem.visible !== false) {
            const data = this.extractInsuranceData(insuranceItem);
            if (data && Object.keys(data).length > 0) {
              metadata.tertiary_insurance.push(data);
            }
          }
        });
      }
    }

    console.log('Final metadata extracted:', metadata);

    // Check if any insurance data actually has values
    const hasData = (insurance) => {
      if (!insurance) return false;
      return Object.values(insurance).some((value) => value && value !== '');
    };

    const hasPrimaryData = hasData(metadata.primary_insurance);
    const hasSecondaryData = metadata.secondary_insurance?.some(hasData);
    const hasTertiaryData = metadata.tertiary_insurance?.some(hasData);

    // Only return metadata if there's actual data
    if (hasPrimaryData || hasSecondaryData || hasTertiaryData) {
      return metadata;
    }

    return {};
  }

  private isRandomlyGeneratedId(id: string): boolean {
    if (!id || typeof id !== 'string') {
      return false;
    }

    const randomIdPattern = /^(secondary|tertiary)_\d+_[a-z0-9]+$/i;
    return randomIdPattern.test(id);
  }

  private extractInsuranceData(insuranceItem: any): any {
    const result: any = {};

    if (!insuranceItem || !insuranceItem.items || !Array.isArray(insuranceItem.items)) {
      return result;
    }

    if (insuranceItem.insurance_id && !this.isRandomlyGeneratedId(insuranceItem.insurance_id)) {
      result.id = insuranceItem.insurance_id;
    }

    const fieldMapping: { [key: string]: string } = {
      'Plan Name': 'company_code',
      'Effective Date': 'effective_date',
      'Expiration Date': 'expiration_date',
      'Policy Number': 'policy_number',
      'Group Number': 'group_number',

      'Address 1': 'address1',
      'Address 2': 'address2',
      City: 'city',
      State: 'state',
      ZIP: 'postal',
      Phone: 'phone_number',

      'Relationship to Client': 'ph_relationship',
      'Employer Name': 'ph_employer',
      'First Name': 'ph_first_name',
      'Last Name': 'ph_last_name',
      Gender: 'ph_gender',
      'Date of Birth': 'ph_birth_date',
      'Zip/Postal': 'ph_postal',
      'Phone Number': 'ph_phone_number',
    };

    insuranceItem.items.forEach((group: any) => {
      if (group.value === false || group.visible === false) {
        return;
      }

      const groupTitle = (group.title || '').toLowerCase();
      const isPolicyHolder = groupTitle.includes('policy holder');

      if (group.items && Array.isArray(group.items)) {
        group.items.forEach((field: any) => {
          if (field.visible === false) {
            return;
          }

          let fieldName = field.name;
          if (!fieldName && field.title) {
            fieldName = fieldMapping[field.title];

            if (isPolicyHolder && field.title === 'Address 1') {
              fieldName = 'ph_address1';
            } else if (isPolicyHolder && field.title === 'Address 2') {
              fieldName = 'ph_address2';
            } else if (isPolicyHolder && field.title === 'City') {
              fieldName = 'ph_city';
            } else if (isPolicyHolder && field.title === 'State') {
              fieldName = 'ph_state';
            }
          }

          if (!fieldName) {
            console.warn('Could not determine field name for:', field.title);
            return;
          }

          let fieldValue = field.value !== undefined && field.value !== null ? field.value : '';

          if (field.type === 'date' && fieldValue) {
            fieldValue = parseLocalDateString(fieldValue);
          }

          if (fieldName === 'effective_date' || fieldName === 'expiration_date') {
            if (!fieldValue || fieldValue === '') {
              return;
            }

            if (typeof fieldValue === 'string') {
              const dateMatch = fieldValue.match(/^(\d{4})-\d{2}-\d{2}$/);
              if (!dateMatch) {
                return;
              }

              const year = parseInt(dateMatch[1], 10);
              if (year < 1910) {
                return;
              }
            }
          }

          if (field.type === 'dropdown') {
            if (fieldName === 'company_code') {
              if (typeof fieldValue === 'object' && fieldValue) {
                result.company_code = fieldValue.PayerId || '';
                result.company_name = fieldValue.Name || '';
              } else {
                result.company_code = fieldValue || '';
              }
            } else if (field.options && Array.isArray(field.options)) {
              result[fieldName] = fieldValue || '';
            } else {
              result[fieldName] = fieldValue || '';
            }
          } else {
            result[fieldName] = fieldValue !== undefined && fieldValue !== null ? fieldValue : '';
          }
        });
      }
    });

    return result;
  }
}
